import { requestApi } from 'api/Api';

import { ia } from 'lib/helpers/utility';

import { showAlert } from 'components/shared/Alert/Alert';
import Icon from 'components/shared/Icon/Icon';

import KioskCounter from '../components/KioskCounter';

const OptionCustomIcon = ({ icon, color }) => (
  <div className="flex h-[38px] w-[38px] items-center justify-center rounded-lg bg-primary-50 p-2 group-hover:!bg-white">
    <Icon icon={icon} color={!color && 'primary'} customColor={color} />
  </div>
);

const OptionCustomLabel = ({ label, kiosk }) => (
  <div className="flex max-w-[120px] flex-col">
    <span className="truncate text-sm font-500 text-primary-900" title={label}>
      {label}
    </span>
    {(kiosk?.user?.p_name || kiosk?.user?.f_name || kiosk?.user?.l_name) && (
      <span
        className="truncate text-xs text-neutral-600"
        title={`${kiosk.user?.p_name || kiosk.user?.f_name || ''} ${kiosk.user?.l_name || ''}`}>
        {`${kiosk.user?.p_name || kiosk.user?.f_name || ''} ${kiosk.user?.l_name || ''}`}
      </span>
    )}
  </div>
);

const OptionCustomRightIcon = ({ kiosk }) => (
  <div className="ml-auto flex flex-col text-right">
    {kiosk?.started_at && <KioskCounter kiosk={kiosk} />}
    <p className="text-sm font-medium text-primary-600">{kinds[kiosk?.current_page || 'idle']}</p>
  </div>
);

const kinds = {
  idle: 'Idle',
  payment: 'Payment',
  form: 'Form',
  signature: 'Signature'
};

export const getOptions = ({ kiosks, requestCount, setShowRequests, setShowPatients }) => {
  const actionOptions = [
    {
      label: <OptionCustomLabel label="Requests" />,
      className: 'group',
      textClassName: 'font-medium',
      icon: <OptionCustomIcon icon="task-1-mono" />,
      rightIcon: (
        <div className="ml-auto flex size-5 items-center justify-center rounded-full bg-primary-900 !px-2 py-[2px] text-xs font-medium text-white">
          {requestCount}
        </div>
      ),
      onClick: () => setShowRequests(true)
    },
    ...(ia(kiosks)
      ? kiosks.map((kiosk) => ({
          className: 'group',
          textClassName: 'font-medium',
          label: <OptionCustomLabel label={kiosk?.name} kiosk={kiosk} />,
          icon: <OptionCustomIcon icon="kiosk-mono" color={kiosk?.color} />,
          rightIcon: <OptionCustomRightIcon kiosk={kiosk} />,
          children: [
            {
              label: 'New Payment',
              icon: 'money-send-mono',
              onClick: () => setShowPatients({ kiosk, type: 'payment' })
            },
            {
              label: 'Send Form',
              icon: 'clipboard-text-mono',
              onClick: () => setShowPatients({ kiosk, type: 'form' })
            },
            {
              label: 'Idle',
              icon: 'timer-1-mono',
              onClick: () =>
                requestApi({
                  url: '/api/kiosk/command',
                  params: {
                    command: 'idle',
                    kioskId: kiosk.id
                  },
                  onSuccess: () => {
                    showAlert({
                      title: 'Kiosk set to idle!',
                      message: 'Kiosk will now display the idle screen',
                      color: 'success'
                    });
                  }
                })
            }
          ]
        }))
      : [])
  ];

  return actionOptions;
};

export default getOptions;
